<template>
    <v-container fluid grid-list-md class="buy-ip">
        <div class="headline ma-3 text-color-vip bold">
            Hỗ trợ
        </div>
        <div class="container-tabs" v-if="maintain == 0">
            <h1 class="maintain_notice">Chức năng này đang bảo trì</h1>
        </div>
        <template v-else>
            <v-layout row wrap class="statistic_status_area">
                <v-flex md4 class="status_wait">
                    <div class="card bg-warning-3 h-100">
                        <div class="card-body py-2">
                            <div class="row align-items-center">
                                <div class="col-auto pr-0"><i class="material-icons font-light cl-warning">query_builder</i></div>
                                <div class="col text-right pl-0"><h6 class="bold mb-0 cl-warning">Chờ hỗ trợ</h6>
                                    <h3 class="bold mb-0"><span>{{ this.statusWait }}</span></h3></div>
                            </div>
                        </div>
                    </div>
                </v-flex>
                <v-flex md4 class="status_doing">
                    <div class="card bg-warning-3 h-100">
                        <div class="card-body py-2">
                            <div class="row align-items-center">
                                <div class="col-auto pr-0"><i class="material-icons font-light cl-warning">help_outline</i></div>
                                <div class="col text-right pl-0"><h6 class="bold mb-0 cl-warning">Đang hỗ trợ</h6>
                                    <h3 class="bold mb-0"><span>{{ this.statusDoing }}</span></h3></div>
                            </div>
                        </div>
                    </div>
                </v-flex>
                <v-flex md4 class="status_done">
                    <div class="card bg-warning-3 h-100">
                        <div class="card-body py-2">
                            <div class="row align-items-center">
                                <div class="col-auto pr-0"><i class="material-icons font-light cl-warning">check_circle_outline</i></div>
                                <div class="col text-right pl-0"><h6 class="bold mb-0 cl-warning">Đã hỗ trợ</h6>
                                    <h3 class="bold mb-0"><span>{{ this.statusDone }}</span></h3></div>
                            </div>
                        </div>
                    </div>
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex xs12>
                    <div class="card card-default">
                        <div class="card-header">
                            <h3 class="card-title">Hỗ trợ của bạn</h3>
                        </div>
                        <div class="card-body table-responsive">
                            <v-card-title>
                                <v-select
                                    solo
                                    :items="typeList"
                                    v-model="type"
                                    item-text="text"
                                    item-value="value"
                                    class="type_list"
                                ></v-select>
                                <button class="btn btn-md btn-md-none btn-block text-white font-14 bg-green bold create_ticket">
                                    <a href="/ticket/create"><i class="mdi mdi-plus"></i> Tạo hỗ trợ mới</a>
                                </button>
                            </v-card-title>
                            
                            <v-data-table
                                :items="desserts"
                                :options.sync="options"
                                :server-items-length="totalDesserts"
                                :loading="loading"
                                class="ticket_list"
                            >
                                <template v-slot:item = "{item}">
                                    <v-col cols="12" class="row_list">
                                        <router-link :to="{name: 'ticket_reply', params: {id: item.id}}" class="">
                                            <v-card
                                                class="mx-auto"
                                                flat>
                                                <v-list-item class="pr-3 ml-5">
                                                    <v-row>
                                                        <div class="pa-0">
                                                            <v-avatar>
                                                                <img :src="avatar_customer" alt="">
                                                            </v-avatar>
                                                        </div>

                                                        <div class="ml-xs-1 ml-sm-3">
                                                            <span class="primary--text body-2 font-weight-bold">
                                                                <span class="red--text">#{{ item.id }}:</span> {{ item.content }}
                                                            </span><br />
                                                            <span class="body-2">
                                                                <span class="mr-2 status_name">{{ item.status_name }}</span>
                                                                <span class="mr-2 type_name">{{ item.type_name }}</span>
                                                            </span>
                                                        </div>
                                                        
                                                        <div class="ml-xs-1 ml-sm-3 aligh_right">
                                                            <span class="float-right d-flex detail_right">
                                                                Chi tiết <i class="mdi mdi-menu-right"></i>
                                                            </span><br />
                                                            <span class="body-2">
                                                                <span class="count_reply">
                                                                    <i class="mdi mdi-comment-processing-outline"></i>
                                                                    {{ item.count_reply }}
                                                                </span>
                                                                <span class="time_elapsed">
                                                                    <i class="mdi mdi-clock-time-five-outline"></i>
                                                                    {{ item.time_elapsed }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </v-row>
                                                </v-list-item>
                                            </v-card>
                                        </router-link>
                                    </v-col>
                                </template>
                                
                            </v-data-table>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </template>
    </v-container>
</template>

<script>
    import {
        CONFIG_PAGE,
        TICKET_GET_LIST
    } from "~/store/actions.type";
    export default {
        components: {},
        data() {
            return {
                maintain: 1,
                statusWait: 0,
                statusDoing: 0,
                statusDone: 0,
                typeList: [],
                type: '',
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                headers: [],
                avatar_customer : 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRb3cKuVSY5yQSumCbZVZJf05ere11Tt1sOSRrNYc425RBOUjS0',
            }
        },
        created() {
        },
        watch: {
            options: {
                handler () {
                    this.getDataApiTicketList()
                        .then(data => {
                            this.desserts = data.items
                            this.totalDesserts = data.total
                        })
                },
                deep: true,
            },
            type () {
                this.options.page = 1
                this.getDataApiTicketList()
                    .then(data => {
                        this.desserts = data.items
                        this.totalDesserts = data.total
                        this.statusWait = data.statistic_status['1']
                        this.statusDoing = data.statistic_status['2']
                        this.statusDone = data.statistic_status['3']
                    })
            }
        },
        mounted() {
            this.getDataApiTicketList()
                .then(data => {
                    this.desserts = data.items
                    this.totalDesserts = data.total

                    this.statusWait = data.statistic_status['1']
                    this.statusDoing = data.statistic_status['2']
                    this.statusDone = data.statistic_status['3']
                    this.typeList = data.type_list
                    this.typeList[0]['text'] = 'Không lọc hỗ trợ'
                    this.type = this.typeList[0]['value']
                });
        },
        methods: {
            async getDataApiTicketList () {
                await this.$store.dispatch(CONFIG_PAGE).then((data) => {
                    let ticketPageStatus = data.filter(o => o.key == 'key_cp_ticket_customer');
                    this.maintain = parseInt(ticketPageStatus[0]['status']);
                });
                this.loading = true
                const { sortBy, sortDesc, page } = this.options

                let pageNumber = page.page || this.options.page
                let rowsPerPage = page.itemsPerPage || this.options.itemsPerPage
                
                let data = await this.$store.dispatch(TICKET_GET_LIST, {
                    'type': this.type,
                    'page': pageNumber,
                    'rowsPerPage': rowsPerPage
                })
                this.avatar_customer = data.avatar.customer;
                let items = data.items
                let statistic_status = data.statistic_status
                let type_list = data.type_list
                const total = data.total

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]
                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }
                this.loading = false
                return { items, total, statistic_status, type_list }
            },
        },
    };
</script>
<style lang="scss">
    @import "../../scss/main";

    .text-color {
        color: $mainColor;
        font-weight: bold;
    }

    .headline{
        background-color: unset;
    }
    .statistic_status_area .status_wait .card-body{
        background-color: #fff8eb!important;
    }
    .statistic_status_area .status_doing .card-body{
        background-color: #e1e9ff!important;
    }

    .statistic_status_area .status_done .card-body{
        background-color: #c9f7f5!important
    }
    
    .statistic_status_area .info-box .row{
        padding: 1.25rem;
    }
    .statistic_status_area .info-box .row div{
        padding: 0;
    }
    .statistic_status_area .flex.md4 {
        padding-right: 15px !important;
        padding-left: 15px !important;
    }
    .statistic_status_area .v-application .pr-0 {
        padding: 20px 10px!important;
    }
    .statistic_status_area h6{
        color: #ff9a02!important;
        font-size: 1rem;
        font-weight: bold;
    }
    
    div.type_list {
        flex: 0 0 auto;
    }
    
    button.create_ticket {
        background-color: #1fab89 !important;
        cursor: pointer;
        font-size: 95%;
        outline: 0 !important;
        vertical-align: middle;
        transition: color .15s ease, background-color .15s ease, border-color .15s ease, box-shadow .15s ease, -webkit-box-shadow .15s ease;
        color: #fff !important;
        display: inline-block;
        font-weight: 400;
        color: #464e5f;
        text-align: center;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        padding: .65rem 1rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 4px !important;
        margin-bottom: 2rem;
        margin-left: 10px;
    }
    button.create_ticket a{
        color: #fff;
    }

    .ticket_list .v-avatar{
        border-radius: unset;
    }
    
    .ticket_list .v-card {
        margin: 5px 0px;
        background-color: unset !important;
    }

    .ticket_list .v-card .v-list-item{
        margin-left: 0 !important;
    }
    
    .ticket_list .row_list {
        background-color: #f5f7fa!important;
        margin: 1.5rem 0 !important;
    }
    
    .ticket_list span.mr-2 {
        font-size: 80%!important;
        font-weight: 400!important;
        border-radius: 20px;
        color: #fff;
        padding: 3px 10px;
    }
    .ticket_list span.status_name {
        background-color: #4cbca1!important;
    }
    .ticket_list span.type_name {
        background-color: #8950fc!important
    }

    .ticket_list div.aligh_right {
        text-align: right!important;
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
        color: #b5b5c3!important;
    }
    .ticket_list i.mdi-menu-right {
        font-size: 150%;
        line-height: 1;
    }

    .ticket_list div.aligh_right .body-2{
        width: 100%;
        float: right;
        font-size: 13px !important;
    }

    .ticket_list div.aligh_right .body-2 .count_reply{
        background-color: #c9f7f5 !important;
        border-radius: 4px;
        padding-right: .5rem !important;
        margin-right: .5rem !important;
        padding-left: .5rem !important;
        color: #1fab89 !important;
    }
</style>
